import { Helmet } from "react-helmet-async"

export default function Overview() {
  return (
    <>
      <Helmet>
        <title>Overview - Pranaam Hospitals</title>
      </Helmet>
      
      <div className="min-h-screen bg-gray-50">
        <div className="relative h-64 md:h-96 bg-gradient-to-r from-brand-teal to-brand-nickel">
          <img src="/images/PranaamHospitals.png" alt="Pranaam Hospitals" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white text-center px-4">Overview</h1>
          </div>
        </div>

        <div className="container mx-auto px-4 py-8 md:py-16">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6 md:p-10">
            <h2 className="text-2xl md:text-3xl font-bold text-brand-teal mb-6">About Pranaam Hospitals</h2>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="text-base md:text-lg">
                Pranaam Hospitals is a leading healthcare provider committed to delivering world-class medical services with compassion and excellence. Established with a vision to provide accessible, affordable, and quality healthcare, we have grown to become a trusted name in the region.
              </p>
              
              <div className="grid md:grid-cols-2 gap-6 my-8">
                <div className="bg-brand-teal/10 p-6 rounded-lg">
                  <h3 className="text-xl font-bold text-brand-teal mb-3">Our Presence</h3>
                  <p>4 state-of-the-art facilities across Hyderabad serving thousands of patients annually</p>
                </div>
                <div className="bg-brand-nickel/10 p-6 rounded-lg">
                  <h3 className="text-xl font-bold text-brand-nickel mb-3">Our Expertise</h3>
                  <p>20+ specialized departments with experienced medical professionals</p>
                </div>
              </div>

              <p className="text-base md:text-lg">
                Our hospitals are equipped with cutting-edge technology and staffed by highly qualified medical professionals who are dedicated to providing personalized care. From routine check-ups to complex surgeries, we offer comprehensive healthcare solutions under one roof.
              </p>

              <img src="/images/ModernHospitalFacility.png" alt="Modern Hospital Facility" className="w-full h-auto max-h-96 object-contain rounded-lg shadow-md my-8" />

              <h3 className="text-xl md:text-2xl font-bold text-brand-teal mt-8 mb-4">What Sets Us Apart</h3>
              <ul className="space-y-3 list-disc list-inside">
                <li>Patient-centric approach with personalized care plans</li>
                <li>Advanced medical technology and infrastructure</li>
                <li>Experienced team of doctors and healthcare professionals</li>
                <li>24/7 emergency services across all locations</li>
                <li>Affordable healthcare without compromising on quality</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
